import useAuthenticatedApi from '@/src/Authentication/components/hooks/useAuthenticatedApi';
import useUserOrg from '@/src/Authentication/components/hooks/useUserOrg';
import { useEffect, useState } from 'react';

interface License {
    type: string;
    key: string;
    expires_at: string;
}

export default function useCurrentLicense() {
    const { org } = useUserOrg();
    const [currentLicense, setCurrentLicense] = useState<License | null>(null);
    const authenticatedApi = useAuthenticatedApi();

    useEffect(() => {
        const fetchLicense = async () => {
            const response = await authenticatedApi.get(
                `/licenses/org/${org.id}/active`,
            );
            console.log('response', response);
            setCurrentLicense(response.data);
        };

        fetchLicense();

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [org]);

    return { license: currentLicense };
}
